"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityStatementsAddButton from "../add/UserPageIdentityStatementsAddButton";
import { createPossessionStr } from "@/helpers/Helpers";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
export default function UserPageIdentityAddStatementsHeader(t0) {
  const $ = _c(31);
  const {
    profile
  } = t0;
  const account = useSeizeConnectContext();
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  const [isMyProfile, setIsMyProfile] = useState(false);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== isMyProfile || $[2] !== profile?.handle) {
    t1 = () => isMyProfile && !activeProfileProxy && !!profile?.handle;
    $[0] = activeProfileProxy;
    $[1] = isMyProfile;
    $[2] = profile?.handle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getCanEdit = t1;
  let t2;
  if ($[4] !== getCanEdit) {
    t2 = getCanEdit();
    $[4] = getCanEdit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [canEdit, setCanEdit] = useState(t2);
  let t3;
  if ($[6] !== getCanEdit) {
    t3 = () => setCanEdit(getCanEdit());
    $[6] = getCanEdit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== activeProfileProxy || $[9] !== isMyProfile) {
    t4 = [isMyProfile, activeProfileProxy];
    $[8] = activeProfileProxy;
    $[9] = isMyProfile;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== account.address || $[12] !== profile) {
    t5 = () => {
      if (!account.address) {
        setIsMyProfile(false);
        return;
      }
      setIsMyProfile((profile.wallets ?? []).some(wallet => wallet.wallet.toLowerCase() === account.address.toLowerCase()));
    };
    $[11] = account.address;
    $[12] = profile;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== account || $[15] !== profile) {
    t6 = [account, profile];
    $[14] = account;
    $[15] = profile;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t5, t6);
  const t7 = profile?.handle ?? null;
  let t8;
  if ($[17] !== t7) {
    t8 = createPossessionStr(t7);
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const [possessionName, setPossessionName] = useState(t8);
  let t9;
  if ($[19] !== profile?.handle) {
    t9 = () => {
      setPossessionName(createPossessionStr(profile?.handle ?? null));
    };
    $[19] = profile?.handle;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== profile) {
    t10 = [profile];
    $[21] = profile;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEffect(t9, t10);
  let t11;
  if ($[23] !== possessionName) {
    t11 = <h3 className="tw-mb-0 tw-text-xl tw-font-semibold tw-text-iron-100">{possessionName} ID Statements</h3>;
    $[23] = possessionName;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== canEdit || $[26] !== profile) {
    t12 = canEdit && <UserPageIdentityStatementsAddButton profile={profile} />;
    $[25] = canEdit;
    $[26] = profile;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div><div className="tw-hidden lg:tw-flex tw-items-center tw-justify-between tw-gap-x-3 tw-w-full">{t11}{t12}</div></div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}